/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAppointmentStatusEnum } from './UserAppointmentStatusEnum';
import {
    UserAppointmentStatusEnumFromJSON,
    UserAppointmentStatusEnumFromJSONTyped,
    UserAppointmentStatusEnumToJSON,
    UserAppointmentStatusEnumToJSONTyped,
} from './UserAppointmentStatusEnum';

/**
 * Response for an appointment for a user
 * @export
 * @interface UserAppointmentResponse
 */
export interface UserAppointmentResponse {
    /**
     * UUID of the user appointment
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    uuid: string;
    /**
     * Full name of the patient
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    patientFullName: string;
    /**
     * Full name of the healthpro
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    healthProFullName?: string;
    /**
     * UUID of the healthPro
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    healthProId?: string;
    /**
     * Type of appointment
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    type: string;
    /**
     * UUID of the type of appointment
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    typeId?: string;
    /**
     * Date and time of the appointment
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    dateTime?: string;
    /**
     * Information about the appointment
     * @type {string}
     * @memberof UserAppointmentResponse
     */
    appointmentInfo?: string;
    /**
     * Duration of the appointment (in minutes)
     * @type {number}
     * @memberof UserAppointmentResponse
     */
    duration: number;
    /**
     * 
     * @type {UserAppointmentStatusEnum}
     * @memberof UserAppointmentResponse
     */
    status: UserAppointmentStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserAppointmentResponse
     */
    patientWithoutAppointment?: boolean;
}



/**
 * Check if a given object implements the UserAppointmentResponse interface.
 */
export function instanceOfUserAppointmentResponse(value: object): value is UserAppointmentResponse {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('patientFullName' in value) || value['patientFullName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UserAppointmentResponseFromJSON(json: any): UserAppointmentResponse {
    return UserAppointmentResponseFromJSONTyped(json, false);
}

export function UserAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'patientFullName': json['patientFullName'],
        'healthProFullName': json['healthProFullName'] == null ? undefined : json['healthProFullName'],
        'healthProId': json['healthProId'] == null ? undefined : json['healthProId'],
        'type': json['type'],
        'typeId': json['typeId'] == null ? undefined : json['typeId'],
        'dateTime': json['dateTime'] == null ? undefined : json['dateTime'],
        'appointmentInfo': json['appointmentInfo'] == null ? undefined : json['appointmentInfo'],
        'duration': json['duration'],
        'status': UserAppointmentStatusEnumFromJSON(json['status']),
        'patientWithoutAppointment': json['patientWithoutAppointment'] == null ? undefined : json['patientWithoutAppointment'],
    };
}

export function UserAppointmentResponseToJSON(json: any): UserAppointmentResponse {
    return UserAppointmentResponseToJSONTyped(json, false);
}

export function UserAppointmentResponseToJSONTyped(value?: UserAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'patientFullName': value['patientFullName'],
        'healthProFullName': value['healthProFullName'],
        'healthProId': value['healthProId'],
        'type': value['type'],
        'typeId': value['typeId'],
        'dateTime': value['dateTime'],
        'appointmentInfo': value['appointmentInfo'],
        'duration': value['duration'],
        'status': UserAppointmentStatusEnumToJSON(value['status']),
        'patientWithoutAppointment': value['patientWithoutAppointment'],
    };
}

